import { isExpertRedirect, navigateToExternalUrl } from "@/lib/utils/redirect";
import { LOGIN_PAGE } from "@/settings/constant";
import { useRouter } from "next/router";
import { useCallback } from "react";
const HOME_PATH = "/";
const LOGIN_PATH = LOGIN_PAGE;
export const REDIRECT_QUERY = "redirectPath";
const useRedirect = ()=>{
    const router = useRouter();
    const currentPathname = router.asPath;
    const loginPath = "".concat(LOGIN_PATH, "?").concat(REDIRECT_QUERY, "=").concat(currentPathname);
    const redirectPath = router.query[REDIRECT_QUERY];
    const redirectToLogin = useCallback((customPathname)=>{
        const redirectPathname = customPathname !== null && customPathname !== void 0 ? customPathname : currentPathname;
        router.push({
            pathname: LOGIN_PATH,
            query: {
                [REDIRECT_QUERY]: redirectPathname
            }
        });
    }, [
        router,
        currentPathname
    ]);
    const redirectTo = useCallback((path, customRedirectPath)=>{
        const redirectPathname = customRedirectPath !== null && customRedirectPath !== void 0 ? customRedirectPath : currentPathname;
        router.push({
            pathname: path,
            query: {
                [REDIRECT_QUERY]: redirectPathname
            }
        });
    }, [
        router,
        currentPathname
    ]);
    const redirectBack = useCallback(()=>{
        // expert.solvook.com에서 온 경우 redirectPath(예: expert.solvook.com/handouts)로 리다이렉트
        if (typeof redirectPath === "string" && isExpertRedirect(redirectPath)) {
            navigateToExternalUrl(redirectPath);
            return;
        }
        if (redirectPath) {
            router.replace(redirectPath);
        } else {
            router.replace(HOME_PATH);
        }
    }, [
        router
    ]);
    const redirectAgain = useCallback(async (url, query)=>{
        const hasPath = !!redirectPath;
        if (hasPath) {
            await router.push({
                pathname: url,
                query: {
                    ...query,
                    [REDIRECT_QUERY]: redirectPath
                }
            });
        } else {
            await router.push(url);
        }
    }, [
        router
    ]);
    return {
        loginPath,
        redirectPath: typeof redirectPath === "object" ? redirectPath[0] : redirectPath,
        redirectToLogin,
        redirectBack,
        redirectAgain,
        redirectTo
    };
};
export default useRedirect;
